import {api, wp} from "@/utils/client";

const state = {
    orders: {
        meta: {total: 0, last_page:1, current_page:1}, 
        data:[]
    },
    products: {
        meta: {total: 0, last_page:1, current_page:1},
        data:[]
    },
    request: null,
}

// actions
const actions = {
    async fetchWarehouseOrders(context, page = {}) {
        try {
            let response = await api.get('/teams/'+ context.rootState.teamId +'/warehouse/orders', {params:page});
            if (page.appendResults) context.commit('appendWarehouseOrders', response.data);
            else context.commit('fetchWarehouseOrders', response.data);
            return response;
        } catch (e) { console.log(e); throw e; }
    },
    async fetchWarehouseProducts(context, page = {}) {
        try {
            let response = await api.get('/teams/'+ context.rootState.teamId +'/warehouse/products', {params:page});
            if (page.appendResults) context.commit('appendWarehouseProducts', response.data);
            context.commit('fetchWarehouseProducts', response.data);
            return response;
        } catch (e) { console.log(e); throw e; }
    },
    async createWarehouseRequest(context, data) {
        try {
            let response = await api.post('/teams/'+ context.rootState.teamId +'/warehouse/requests', data);
            context.commit('createWarehouseRequest', response.data);
            return response;
        } catch (e) { console.log(e); throw e; }
    },
    async importWarehouseOrders(context, data) {
        try {
            return await api.post('/teams/'+ context.rootState.teamId +'/warehouse/orders/import', data);
        } catch (e) { console.log(e); throw e; }
    },
    async deleteWarehouseOrders(context, data) {
        try {
            console.log(data);
            return await api.post('/teams/'+ context.rootState.teamId +'/warehouse/orders/delete', data);
        } catch (e) { console.log(e); throw e; }
    },
    async exportFulfilmentHistory(context, item) {
        try {
            let response = await api.get('/teams/' + context.rootState.teamId + '/warehouse/orders/export', {params:item});
            return response;
        } catch (e) { console.log(e); throw e; }
    },
}
// mutations
const mutations = {
    fetchWarehouseOrders(state, data) {
        if (data.data) data.data.forEach((item) => { item.selected = false });
        state.orders = data;
    },
    appendWarehouseOrders(state, data) {
        if (data.data) data.data.forEach((item) => { item.selected = false });
        data.data = [...state.orders.data, ...data.data];
        state.orders = data;
    },
    fetchWarehouseProducts(state, data) {
        if (data.data) data.data.forEach((item) => { item.selected = false });
        state.products = data;
    },
    appendWarehouseProducts(state, data) {
        if (data.data) data.data.forEach((item) => { item.selected = false });
        data.data = [...state.products.data, ...data.data];
        state.products = data;
    },
    createWarehouseRequest(state, data) {
        state.request = data;
    },
}

export default {
    state,
    actions,
    mutations
}
